// Core orchestrator for keyboard nav, selection, and rendering.
// @ts-check
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useTaskListBaseController } from './useTaskListBaseController';

/**
 * @param {{
 *   id: string|null,
 *   isSortable?: boolean,
 *   tasks: Task[],
 *   editingTaskId?: string|null,
 *   onStartEditing?: (id: string) => void,
 *   onStopEditing?: () => void,
 *   selectedTaskIds: string[],
 *   onSelectionChange: (ids: string[]) => void,
 *   selectNewTask?: boolean,
 *   indentationType?: string,
 *   plannedParentIds?: Set<string>,
 *   waitingForParentIds?: Set<string>,
 *   view?: string,
 *   showBreadcrumbs?: boolean,
 *   onBeforeToggleComplete?: (task: Task, completed: boolean) => void,
 * }} props
 */
const TaskListBase = (props) => {
  const { id, isSortable, dragEnabled, items, content } =
    useTaskListBaseController(props);

  if (isSortable || dragEnabled) {
    return (
      <SortableContext
        items={items}
        strategy={verticalListSortingStrategy}
        id={id}
      >
        {content}
      </SortableContext>
    );
  }

  return content;
};

export default TaskListBase;
